import { Flex } from '@shared/components';

export default function QSetGeneratorPage() {
  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        width: '100%',
        height: '100dvh',
        bgcolor: theme.palette.grey[50],
        p: theme.spacing(6),
      })}
    >
      QSetGeneratorPage
    </Flex>
  );
}
